import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=454b50d0&scoped=true"
import script from "./Games.vue?vue&type=script&lang=ts"
export * from "./Games.vue?vue&type=script&lang=ts"
import style0 from "./Games.vue?vue&type=style&index=0&id=454b50d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b50d0",
  null
  
)

export default component.exports